export const RAW_LOCATION_GROUP = {
  34: [21, 24, 67, 68, 71, 72],
  10: [16, 18, 61, 62, 64, 65],
  7: [29, 30, 45, 47, 48, 51, 76],
  36: [2, 3, 4, 32, 35, 40, 55],
  35: [6, 8, 9, 10, 11, 36],
  38: [41, 43],
} as const
